import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import StepRoutes from "../../Routes/steps_routes";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import LoadingPage from "../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcKindle } from "react-icons/fc";


const ViewSiUpdates = ()=>{
    const [data, setData] = useState();
    let { id } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
  
    useEffect(() => {
      setLoading(true);
      performRequest("GET", `/si-updates/getsiUpdatesById/${id}`)
        .then((res) => {
          if (res.status === 200) {
            setData(res.data);
          } else {
            Toast("error", "Error while getting Expense!");
          }
          setLoading(false);
        })
        .catch((err) => {
          // Toast("error", "Server Error!");
          // console.error(err);
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }, [id]);
  
    if (loading) {
      return <LoadingPage />;
    }
  
    return (
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1"><FcKindle ></FcKindle> View SI Updates</h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header row g-2 align-items-center">
                <div className="col">
                  <h2>View SI Updates</h2>
                </div>
                <div className="col-auto ms-auto d-print-none"></div>
              </div>
              <div className="card-body">
                {data && (
                  <>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Name</label>
                      <div className="w-100 col">
                        {(data?.name || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Email</label>
                      <div className="w-100 col">
                        {(data?.email || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Contact number
                      </label>
                      <div className="w-100 col">
                        {(data?.contactNumber || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Watsapp number
                      </label>
                      <div className="w-100 col">
                        {(data?.watsapppNumber || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Enroll date</label>
                      <div className="w-100 col">
                        {(data?.enrollDate || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Amount paid</label>
                      <div className="w-100 col">{data?.amountPaid || "N/A"}</div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Mode of payment
                      </label>
                      <div className="w-100 col">
                        {(data?.paymentMode || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                       Payment Date
                      </label>
                      <div className="w-100 col">
                        {(`${data?.paymentDate}` || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Address
                      </label>
                      <div className="w-100 col">
                        {(`${data?.Address}` || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Generated By
                      </label>
                      <div className="w-100 col">
                      {(`${data?.generatedBy}` || "N/A").toUpperCase()}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  <SimpleButton
                    buttonText="Edit SI Updates"
                    onClick={() => navigate(`/si-updates/edit/${id}`)}
                  />
                  <SimpleButton buttonText="Cancel" type="secondary" />
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
}

export default ViewSiUpdates;